// workspace-repos-manifest-store.ts
//
// v3: workspace KHÔNG git → không có .gitmodules để biết "workspace có repo nào".
// Thay bằng .claude/repos.json do Avatar quản — nguồn sự thật DUY NHẤT về các repo
// code trong src/. Mỗi repo là git clone độc lập.
import { join } from "node:path";
import { pathExists, readJson, writeJsonAtomic } from "./filesystem-helpers.js";

export const REPOS_MANIFEST_RELATIVE = ".claude/repos.json";

export interface RepoEntry {
  name: string; // tên thư mục trong src/ (vd "frontend")
  path: string; // relative từ workspace root (vd "src/frontend")
  url: string; // git remote URL
  addedAt: string; // ISO timestamp
}

interface ReposManifest {
  repos: RepoEntry[];
}

function manifestPath(workspaceRoot: string): string {
  return join(workspaceRoot, REPOS_MANIFEST_RELATIVE);
}

export async function readReposManifest(workspaceRoot: string): Promise<RepoEntry[]> {
  const p = manifestPath(workspaceRoot);
  if (!(await pathExists(p))) return [];
  try {
    const data = await readJson<ReposManifest>(p);
    return Array.isArray(data.repos) ? data.repos : [];
  } catch {
    return [];
  }
}

export async function addRepoToManifest(workspaceRoot: string, entry: RepoEntry): Promise<void> {
  const repos = await readReposManifest(workspaceRoot);
  // Replace nếu cùng name (idempotent), else append.
  const filtered = repos.filter((r) => r.name !== entry.name);
  filtered.push(entry);
  await writeJsonAtomic(manifestPath(workspaceRoot), { repos: filtered });
}

export async function removeRepoFromManifest(workspaceRoot: string, name: string): Promise<void> {
  const repos = await readReposManifest(workspaceRoot);
  await writeJsonAtomic(manifestPath(workspaceRoot), {
    repos: repos.filter((r) => r.name !== name),
  });
}

// Check tên repo đã tồn tại trong manifest chưa (tránh trùng).
export async function repoNameExists(workspaceRoot: string, name: string): Promise<boolean> {
  const repos = await readReposManifest(workspaceRoot);
  return repos.some((r) => r.name === name);
}
